/**
 * internal dependecies
 */
import { COMMON_FORM_ELEMENTS } from "./pin-pool-types";
import { IPinPoolIndivdiual } from "../../../../../models/cardgroup.interface";

/**
 * Checks if a new pin is unique and meets length requirements.  If the pin is not valid, an error is thrown and the input field is highlighted in red.
 * 
 * @param pins A list of existing pins
 * @returns object with isValid boolean and message string
 */
export const checkForUniquePin = ( pins: IPinPoolIndivdiual[] ) => {
  const pinInput = COMMON_FORM_ELEMENTS.cePinNumberInput;
  const ceError = COMMON_FORM_ELEMENTS.ceError;
  const ceSubmit = COMMON_FORM_ELEMENTS.ceSubmitButton;
  const newPin = pinInput.value.trim();

  let errorMessage = '';

  if (newPin.length >= 49) {
    errorMessage = 'Pin cannot be greater than 49 characters';
  } else if (newPin.length < 4) {
    errorMessage = 'Pin cannot be less than 4 characters';
  } else if (pins.some((pin) => pin.validValue === newPin)) {
    // Only run duplicate check when length validation has already passed.
    errorMessage = 'Pin must be unique';
  }

  if (errorMessage) {
    ceError.textContent = errorMessage;
    pinInput.classList.add('invalid-pins');
    ceSubmit.disabled = true;
    return;
  }

  pinInput.classList.remove('invalid-pins');
  ceError.textContent = '';
  ceSubmit.disabled = false;
  return;
};